import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalConfirmComponent } from './modal-confirm.component';

@NgModule({
  providers: [],
  exports: [ModalConfirmComponent],
  declarations: [ModalConfirmComponent],
  imports: [
    CommonModule,
    OverlayModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
  ],
})
export class ModalConfirmModule {
  constructor() {}
}
